import 'owl.carousel';
import Plyr from 'plyr';
import $ from 'jquery';
import select2 from 'select2';
import fancybox from '@fancyapps/fancybox';
import Steps from 'jquery.steps'; 
import Validate from 'jquery-validation'; 
import MCustomScrollbar from 'malihu-custom-scrollbar-plugin'; 
import print from 'print-js';


export default class Script { 

    init() {
        this.owlintroSlider();
        this.owlVideoEdito();
        this.owlPlayer();
        this.owlMission();
        this.owlTemoignages();
        this.campusCarousel();
        this.multiplePlayer();
        this.owlGallerie();
        this.owlPartenaire();
        this.selectOption();
        this.fileName();
        this.steps();
        this.accordionFaq();
        this.planSite();
        this.headerMobile();
        this.customScrollbar();
        this.owlActu();
        this.scrollToNext();
        this.onchangeUpload();
        this.customNextBtnPosition();
        this.inscriptiononChange();
        this.datepicker();
        this.disabledSelect();
        if ($(window).width() > 991) {
          this.titleSticky(); 
        }
        if ($(window).width() < 768) {
          this.owlCarouselMobile();
          this.selectFaqMobile();
        }
        this.faqUrl();
      } 

    
    faqUrl() {
      if($('.faq-content').length) {

        $('.faq-content h4').click(function() {
          let baseUrl = window.location.origin;
          let url = $(this).data('tag');
          history.pushState({}, '', url.split(baseUrl)[1]);
        });
        
      }
    }

    disabledSelect() {
      if($('.post-formation-sing-up').length) {
        if(($('.post-formation-sing-up select option').length)<3) {
          $('.post-formation-sing-up .ss-arrow').hide();
        }
        
        $(".post-formation-sing-up .ss-single-selected").on("click", function () {
          if(($('.post-formation-sing-up select option').length)<3) {
            $('.post-formation-sing-up .ss-arrow').hide();
            $(".post-formation-sing-up .ss-content").hide();
            var topOfElement = document.querySelector('.details-formation-sessions').offsetTop;
            document.querySelector(".modal-content").scroll({ top: topOfElement, behavior: "smooth" });
          }
        });
              
      }
      

    }

    datepicker() {
      if($('#datepicker').length) {

          let lang = $('html')[0].lang;
          let shortLang = lang;
          if (shortLang.indexOf('-') !== -1)
              shortLang = shortLang.split('-')[0];
          
          if (shortLang.indexOf('_') !== -1)
              shortLang = shortLang.split('_')[0];

          $('#datepicker').datepicker({
            format: "mm/yyyy",
            startView: 1,
            minViewMode: 1,
            autoclose: true,
            clearBtn: true,
            language: shortLang,
            defaultViewDate: "mm/yyyy"
          }).datepicker('clearDates');

          var data = $('#datepicker').attr("data-value");
        
          if(data.length) {
            $('#datepicker').datepicker( "setDate" , data );
          }
        
     

            //select
            $(".lang-switch").change(function(){
              var selectedCountry = $('.lang-switch option:selected').val();
              //$.datepicker.setLanguage('en');
              $('#datepicker').datepicker('remove');
              $('#datepicker').datepicker({
                format: "mm/yyyy",
                startView: 1,
                minViewMode: 1,
                autoclose: true,
                clearBtn: true,
                language: selectedCountry,
              }).datepicker('clearDates');
          });

      }

    }
    titleSticky() {
      if($('.page-campus .gab-formations').length) {
       
        var elementOffset = $('.nos-formations').offset().top;
        var elementHeight = $('.nos-formations').innerHeight();
        var formationHeight= $('.col-frm-right').height();
        var formationOffsetBottom = ($('.col-frm-right').offset().top) + (formationHeight - elementHeight);
        var heightViewport = $(window).height();
        var positionAfterfixed;

        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop();

          var bottomViewport = scrollTop + (heightViewport/2);

          //var phantomHeight = $('.nos-formations').outerHeight();

          if((scrollTop  >= (elementOffset)) && (formationHeight > heightViewport)) {
            $('.nos-formations').addClass('sticky-t');
            //$('#sticky-phantom').height(phantomHeight).show();

          } else {
            $('.nos-formations').removeClass('sticky-t');
            $('.nos-formations').parent().removeClass('aftersticky-t');
            //$('#sticky-phantom').hide();
          }

          if(scrollTop >= formationOffsetBottom) {
            $('.nos-formations').removeClass('sticky-t');
            $('.nos-formations').parent().addClass('aftersticky-t');
          }
         
          //console.log("scroll top win : "+elementHeight);
          //console.log("element off : "+elementOffset);

        });
            
            //distance      = (elementOffset - scrollTop);
      }
    }

    inscriptiononChange() {
      $('.situation-select').change(function(){
        var slug = $(this).find(':selected').attr('data-slug');

        if( (slug == "salarie") || (slug == "employee") ) {  
          $('.salarie-wrp').show();
        } else {
          $('.salarie-wrp').hide(); 
        }

      });
    }
    onchangeUpload() {
      /*$('.custom-upload input').change(function(){
        var file = $('.custom-upload input');
        $('.file').html(file.val());
        var text = $('.file').html();
        text = text.substring(text.lastIndexOf("\\") + 1, text.length);
        $('.file').html(text);
      });*/
    }
    scrollToNext() {
        if($('#steps').length) {
          $('.step-footer .next').click(function() {
            $('html, body').animate({
              scrollTop: $(".remerciements").offset().top
            }, 500);
          });
        }
    }
    owlActu() {
      if($(window).width() <= 767) {
        if($('.owl-actu').length) {
          var owl = $('.owl-actu');

          owl.owlCarousel({
              items: 1,
              nav: false,
          });
        }
      }
    }
    customScrollbar() {
      if($(window).width() > 767) {
        if($('.customScrollbar').length) {
          $('.customScrollbar').mCustomScrollbar({
            axis:"x",
            theme:"dark",
          }); 
        }
      }
    }

    steps() {

      var myForm = $("#myForm");
      //var form_2 = $("#form_step2");
      //var form_3 = $("#form_step3");
      /*var file = $('#cv-upload');
      var RegEx = new RegExp("^.*\.(pdf|PDF)$");

      RegEx.test(file);*/


      var errorMsg = $('#steps').data('error');

      $.validator.messages.required = errorMsg;

      //upload error 

      $( "#cv-upload" ).change(function() {
        if($('#cv-upload-error').length) {
          $('#cv-upload-error').remove();
        }
      });
      $( "#lettre-upload" ).change(function() {
        if($('#lettre-upload-error').length) {
          $('#lettre-upload-error').remove();
        }
      });

      //select error
      $('select').on('change', function () {
        if($(this).hasClass('error')) {
          $(this).next().remove();
          $(this).removeClass('error');
        }
      });

      //select date error 
      $('.content-date select').on('change', function () {
        if($('.content-date .error-select').length == 0) {
          $('.error-date').remove();
        }
      });
    
      var formValidate_2 = myForm.validate({
        rules: {
          verif_email: {
            equalTo: "#email"
          },
          civilite: {
            required:true,
          },
          permis: {
            required:true,
          },
          prerequis: {
            required : true,
          }
        },

        showErrors: function(errorMap, errorList) {
          this.defaultShowErrors();

         if($('.form-checkbox input').is(':checked')) {
            $('#prerequis-error').remove();
         }

          if($('select').hasClass('error')) {
            $('select +.error').addClass("error-select");
          }

          if($('#email-error').length) {
            $('#email-error').parent().css("margin-bottom","8px");
            if ($(window).width() < 991) {
              $('#email-error').parent().css("margin-bottom","20px");
            }
          }

          if($('#verif_email-error').length) {
            $('#verif_email-error').parent().css("margin-bottom","8px");
          }

          if($('#tel-error').length) {
            $('#tel-error').parent().css("margin-bottom","16px");
          }

          //radio btn error
          if($('#civilite-error').length) {
            $('.first-civilite').append($('#civilite-error'));
          }
          if($('#permis-error').length) {
            $('.first-permis').append($('#permis-error'));
          }

          //date error
          if($('.content-date label.error').length) {
            $('.content-date').find('label.error').hide();
            if($('.error-date').length == 0) {
              $('.content-date').append("<span class='error-date'>"+errorMsg+"</span>");
            }
          }
          
        },
      });
      
      var formValidate_3 = myForm.validate({
        rules: {
          cv_uploadname : {
            required:true,
            extension: "pdf",
            filesize: 2,
            accept: "application/pdf"
          },
          lettre_uploadname : {
            required:true, 
            extension: "pdf",
            filesize: 2,
            accept: "application/pdf"
          }
        },
        debug: true,

        showErrors: function(errorMap, errorList) {
          this.defaultShowErrors();

          if($('#cv-upload-error').length) {
              $('.cv').css('margin-bottom','15px');
          }

          if($('#lettre-upload-error').length) {
              $('.lettre').css('margin-bottom','15px');
          }
        },

        submitHandler: function() {
          $successMsg.show();
        }
      });
      
      if($('#steps').length) {
        
        $("#steps").steps({
          headerTag: "h3",
          bodyTag: "section",
          transitionEffect: "slideLeft",
          autoFocus: true,
          onChange: function(currentIndex, newIndex, stepDirection){
            
            if (currentIndex === 0) {
              if (stepDirection === 'forward') {
                var formValidate = myForm.validate({

                  showErrors: function(errorMap, errorList) {
                    this.defaultShowErrors();
                    if($('select').hasClass('error')) {
                      $('select +.error').addClass("error-select");
                    }
                  },
          
                  submitHandler: function() {
                    $successMsg.show();
                  }
                });
                return myForm.valid();
              }
              if (stepDirection === 'backward') {
                formValidate.resetForm();
              }
            }

            if (currentIndex === 1) {
              if (stepDirection === 'forward') {
                     
                return myForm.valid();
              }
              if (stepDirection === 'backward') {
                formValidate_2.resetForm();
              }
            }

            if(currentIndex === 2 ) {
              if (stepDirection === 'forward') {

                return myForm.valid();
              }
              if (stepDirection === 'backward') {
                formValidate_3.resetForm();
              }
              $('.finish').addClass('displayBlock');
              $('.next').addClass('hideBlock');
            }
            return true;
          },
          onFinish: function() {
              myForm.submit();
          }
        });

      }

      $('#myForm .finish').on('click',function() {
        setTimeout(function() {
                $("#myForm .finish").attr("disabled", true);
        }, 1);
      });
    }

    fileName() {
      $('#file-upload').on('change', function(){
        $('.custom-file-upload span').text($(this).val());
      });

      $('#cv-upload').on('change', function(){
        var t = $(this).val();
        var text = t.substring(t.lastIndexOf("\\") + 1, t.length);

        $( "<span class='file'>"+text+"</span>" ).insertAfter( ".cv .no-file" );
        $('.cv').addClass('active');
        
      });

      $('#lettre-upload').on('change', function(){
        var t = $(this).val();
        var text = t.substring(t.lastIndexOf("\\") + 1, t.length);

        $( "<span class='file'>"+text+"</span>" ).insertAfter( ".lettre .no-file" );
        $('.lettre').addClass('active');

      });
      
      $(".icon-cross").click(function() {
        $(this).parent().find($('.file')).remove();
        $(this).parent().removeClass('active');
      });
    }
    selectOption(){
      $('.selectLang').on("click touchstart", function (e) {
        e.preventDefault();
        $(this).parents('.lang-switcher').toggleClass('active');


      });
     /* if ($(window).width() > 767) {*/
        $('#select-edito').select2();
        $(".lang-switch .custom-select").on('change', function() {
          window.location.href = $(this).val();
        });
     
        if($('#steps').length) {
          $('.form .custom-select').select2();
        }
        $('.form select').select2();
        $('select').on('select2:open', function (e) {
          $('.select2-results__options').mCustomScrollbar('destroy');
          setTimeout(function () {
            $('.select2-results__options').mCustomScrollbar();
          }, 0);
        });

        $('.content-date .custom-select').on('select2:open', function (e) {
          $('.select2-container--open').addClass('select-form-date');
        });

        $('.tel-group .custom-select').on('select2:open', function (e) {
          $('.select2-container--open').addClass('select-form-date');
        });
      //}
      
    }

    customNextBtnPosition() {
      if($('.hp-intro .customNextBtn').length) {
        var defautPosition = 650;
        var newPosition;
        var heightH = $('.hp-intro .active h1').height();

       /* if(heightH > 390) {
          newPosition = (heightH - 390) + defautPosition;
          $('.hp-intro .customNextBtn').css('top',newPosition);
        } else {
          $('.hp-intro .customNextBtn').css('top',defautPosition);
        }*/
        newPosition = heightH + 10 + 252;
        $('.hp-intro .customNextBtn').css('top',newPosition);
      }
    }

    owlintroSlider() {
      var _that = this;
      if ($(".owl-introSlider").length) {
        var owl = $('.owl-introSlider');
        
        owl.on('initialized.owl.carousel',function(){
          //plyr
            var videoL = $(".owl-introSlider .active .customPlayer").length;
            var curentItem = $(".owl-introSlider .active .customPlayer");

            if (videoL > 0) {
              //const player = new Plyr(curentItem, {autoplay: true, clickToPlay: false});
            }
            
        });

        owl.owlCarousel({
            items: 1,
            nav: false,
            loop: true,
            //rewind: true,
            video: true,
            autoplay : true,
            smartSpeed:1000,
            autoplayTimeout:8000,
            onInitialized: function(property) {
              var current = property.item.index;
              var videoL = $(property.target).find(".owl-item").eq(current).find(".customPlayer").length;
                if (videoL > 0) {
                  $(property.target).find(".owl-item").eq(current).find("video").each(function() {
                    this.play();
                });
              }
              //console.log("test"+current);
            },
            onTranslate: function() {
              $('.owl-item').find('video').each(function() {
                  this.pause();
              });
            },
            onTranslated: function(property) {
              var current = property.item.index;
              var videoL = $(property.target).find(".owl-item").eq(current).find(".customPlayer").length;
                if (videoL > 0) {
                  $(property.target).find(".owl-item").eq(current).find("video").each(function() {
                    this.play();
                });
              }
            }
        });

        $('.customPlayer').on('play', function() {
          owl.trigger('stop.owl.autoplay');
          //console.log("play");
        });

        $('.customPlayer').on('pause', function() {
          owl.trigger('play.owl.autoplay');
          //console.log("play");
        });

        $('.customPlayer').on('ended',function(){
          owl.trigger('play.owl.autoplay');
          //console.log("stop");
        });

        var defautPosition = 650;
        var newPosition;
        var heightH ;

        owl.on('changed.owl.carousel',function(property){
          var current = property.item.index;
          var heightH = $(property.target).find(".owl-item").eq(current).find("h1").height();

          newPosition = heightH + 10 + 252;
          $('.hp-intro .customNextBtn').css('top',newPosition);
        });

        $('.hp-intro .customNextBtn').click(function () {
            owl.trigger('next.owl.carousel');
        });

        var count = $('.owl-introSlider .owl-item').not( $( ".cloned" ) ).length;

        if (count <= 1)  {
          $('.owl-introSlider .owl-dots').hide();
          $('.hp-intro .customNextBtn').hide();
          $(".owl-introSlider .owl-item .item").on("touchstart mousedown", function(e) {
            // Prevent carousel swipe
            e.stopPropagation();
        });
        }
          
      }
    }

    owlVideoEdito() {

      if($(".owl-video-edito").length) {

        //console.log('test');

        var owl = $('.owl-video-edito');
        owl.owlCarousel({
          items: 1,
          nav: true,
          loop: true,
          video: true,
          dots:false,
          navText: ["<i class='icon-arrow-left'></i>","<i class='icon-arrow-right'></i>"],
        });

        $('.video .goNext').on('click', function (e) {
          e.preventDefault();
          owl.trigger('next.owl.carousel');
        });

        var count = $('.owl-video-edito .owl-item').not( $( ".cloned" ) ).length;

        if (count <= 1)  {
          $('.video .goNext').hide();
          $(".owl-video-edito .owl-item .item").on("touchstart mousedown", function(e) {
            // Prevent carousel swipe
              e.stopPropagation();
          });
        }

      }
    }

    owlPlayer() {

      if ($(".playerYoutube").length) {
        $("[data-fancybox]").fancybox({
          loop: false,
          afterShow : function() {
            const player = new Plyr('.player', {});
          }
        });
      }
    }

    owlMission() {

      if ($(".owl-missions-info").length) {
        var owl = $('.owl-missions-info');

        owl.owlCarousel({
            items: 1,
            nav: true,
            navText: ["<span class='icon-arrow-left'></span>","<span class='icon-arrow-right'></span>"],
            //loop: true,
            autoHeight:true,
            rewind: true,
        });

        $('.wrapper-mission-info .customNextBtn').click(function () {
            owl.trigger('next.owl.carousel');
        });

        owl.on('translated.owl.carousel', function(e) {
          var idaCtiveItem = owl.find('.owl-item.active').find('.item').attr('id');
            //console.log(idaCtiveItem);
            $('.missions-position-item').removeClass('active');
            $('.missions-position-item[data-mission="'+idaCtiveItem+'"]').addClass('active');

            //country
            $('.pays li').removeClass('active');
            var dataCountry = $('.missions-position-item[data-mission="'+idaCtiveItem+'"]').data('pays');
            $('.pays li[id="'+dataCountry+'"]').addClass('active');
        });

        $('.missions-position-item').click(function() {


        });


        var count = $('.owl-missions-info .owl-item').not( $( ".cloned" ) ).length;

        if (count <= 1)  {
          $('.mission-info .customNextBtn').hide();
        }
      }

      if ($('.wrapper-mission-info').length) {
        //default values 
        var default_mission = $('.missions-position-item.active').data('mission');
        //$('.wrapper-mission-info').find('#'+default_mission).addClass("active");

        var default_country = $('.missions-position-item.active').data('pays');
        $('.pays').find('#'+default_country).addClass("active");

        //after click
        $('.missions-position-item').click(function() {

          //active marker

          $('.missions-position-item').removeClass('active');
          $(this).addClass('active');

          //active mission-

          var activeCercle_mission =  $(this).data('mission');
          //$('.mission-info').removeClass('active');
          var relatedItemId = $('.owl-missions-info .owl-item').find('#'+activeCercle_mission).parent().index();

          owl.trigger('to.owl.carousel', relatedItemId );
        
          //$('.owl-item').removeClass('active');
          //$('.wrapper-mission-info').find('#'+activeCercle_mission).parent().addClass("active");

          //active country

          var activeCercle_pays =  $(this).data('pays');
          $('.pays li').removeClass('active');
          $('.pays').find('#'+activeCercle_pays).addClass("active");

        });
      }
      
    } 

    owlTemoignages() {

      if ($(".owl-temoignages").length) {
        var owl = $('.owl-temoignages');

        owl.owlCarousel({
            items: 1,
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
            nav: true,
            loop: true,
            navText: ["<span class='icon-arrow-left'></span>","<span class='icon-arrow-right'></span>"],
            responsive: {
              0: {
                autoHeight:true,
              },
              768: {
                autoHeight:false,
              },
            }

        });

        if($(window).width() <= 767) {
          var maxheight = 0;
          var items = $('.owl-temoignages .owl-item');
          for(var i=0 ; i < items.length ; i++ ) {
            var itemHeight = $('.owl-temoignages .owl-item').eq(i).height();
            if(itemHeight > maxheight) {
              maxheight = itemHeight;
            }
            //console.log(itemHeight);
          }
          //console.log(maxheight);
          var heightContainer = maxheight + 33;
          $('.gab-temoignages').css("height",heightContainer);
        }
      }
      
      var count = $('.owl-temoignages .owl-item').not( $( ".cloned" ) ).length;

      if (count <= 1)  {
        $('.owl-temoignages .owl-dots').hide();
        $('.owl-temoignages .owl-item.cloned').remove;
        $(".owl-temoignages .owl-item .item").on("touchstart mousedown", function(e) {
          // Prevent carousel swipe
          e.stopPropagation();
      });
      }

    }

    owlGallerie() {
      if ($("#gallerie-carousel").length) {
        var owl = $("#gallerie-carousel").owlCarousel({
          items: 1,
          nav: true,
          loop: true,
          navText: ["<i class='icon-arrow-left'></i>","<i class='icon-arrow-right'></i>"]
        });
        $('.galeries .goNext').on('click', function (e) {
          e.preventDefault();
          owl.trigger('next.owl.carousel');
        });

        var count = $('#gallerie-carousel .owl-item').not( $( ".cloned" ) ).length;

        if (count <= 1)  {
          $('.galeries .goNext').hide();
          $("#gallerie-carousel .owl-item .item").on("touchstart mousedown", function(e) {
            // Prevent carousel swipe
              e.stopPropagation();
          });
        }
      }
      
    }
    owlPartenaire() {
      if ($("#partenaires-carousel").length) {

        var blocPartenaires = $('.partenaires');

        $('.partenaires').each(function( index ) {
          //console.log( index + ": " + $( this ).text() );

          var isLooped = false;
          var totalItems = $( this ).find($('.owl-carousel img')).length;
  
          if ($(window).width() >= 992 ) {
            if(totalItems > 5) {
              isLooped = true;
            } else {
              isLooped = false;
            }
          }
          else if ($(window).width() < 991) { 
            if(totalItems > 3) {
              isLooped = true;
            } else {
              isLooped = false;
            }
          }
  
          $( this ).find($('.owl-carousel')).owlCarousel({
            items: 5,
            nav: true,
            loop: isLooped,
            navText: ["<i class='icon-arrow-left'></i>","<i class='icon-arrow-right'></i>"],
            responsive: {
              0: {
                items: 1
              },
              768: {
                items: 3
              },
              992: {
                items : 5
              }
            }
          });

        });





        //console.log(totalItems);
        //console.log(isLooped);
      }
      
    }

    multiplePlayer(){
      if ($('.player').length) {
        const players = Array.from(document.querySelectorAll('.player')).map(p => new Plyr(p));
      }
      
    }
    accordionFaq() {
      $('.accordion > li .title').on("click", function(e){
        e.preventDefault();
        if($(this).parent('li').hasClass('active')) {
          $('.accordion > li').removeClass('active');
        } else {
          $('.accordion > li').removeClass('active');
          $(this).parent("li").addClass('active');
        }
          
      });

      $('.listing-accordion > li').on('click', function(e){
        e.preventDefault();

        $('html, body').animate({
          scrollTop: ($(".listing-accordion").offset().top)-80
        }, 300);
     
        if (!$(this).hasClass('active')) {
          $('.listing-accordion > li').removeClass("active");
          $('.accordion').removeClass("active");
          $(this).addClass("active");
          $('.accordion').eq($(this).index()).addClass("active");
          //$('.listing-accordion > li').removeClass('active');
        } 
      });
    }

    campusCarousel(){
      var owl1 = $('#carousel-media');
      owl1.owlCarousel({
          items: 1,
          nav: true,
          loop: true,
          navText: ["<i class='icon-arrow-left'></i>", "<i class='icon-arrow-right'></i>"]
          
      }).on('changed.owl.carousel', function (event) {
        // owl2.trigger('to.owl.carousel', event.item.index);
        owl2.trigger('next.owl.carousel');
      });
      
      var owl2 = $('#carousel-text');
      owl2.owlCarousel({
          items: 1,
          loop: true,
          nav: false,
      });

    }
    planSite() {
      $('.accordion-h4 > li:not(.without-arrow) > h4').on("click", function (e) {
        e.preventDefault();
        if ($(this).parents('li').hasClass('active')) {
          $('.accordion-h4 > li').removeClass('active');
        } else {
          $('.accordion-h4 > li').removeClass('active');
          $(this).parents('li').addClass('active');
        }

      });
    }
    headerMobile() {
      if($(window).width() < 768) {
        $('.icon-burger').on("click", function(){
          if ($('body').hasClass("openedMenu")) {
            $('body').removeClass("openedMenu");
            $('.hamburger').removeClass("is-active");
          } else {
            $('body').addClass("openedMenu");
            $('.hamburger').addClass("is-active");
          }
          
        });
        $('.header-top').clone().appendTo(".header-bottom");
        $('div.logo').clone().prependTo("#header");
        $('.header-search form').clone().prependTo(".header-bottom");

        $('.navbar >li > a').on("click", function(e){
          e.preventDefault();
          if($(this).parent("li").hasClass("active") ){
            $('.navbar >li').removeClass("active");
          } else {
            $('.navbar >li').removeClass("active");
            $(this).parent("li").addClass("active");
          }
          
        });
        $('.navbar .sub-menu > ol > li > a').on("click", function(e){
          if(!($(this).hasClass('no-nav'))) {
            e.preventDefault();
          }
          
          if($(this).parent("li").hasClass("active") ){
            $('.navbar .sub-menu > ol > li').removeClass("active");
          } else {
            $('.navbar .sub-menu > ol > li').removeClass("active");
            $(this).parent("li").addClass("active");
          }
          
        });
      }
      
    }

    owlCarouselMobile() {
      if (!$('.homepage').length) {
        $('.actualites').owlCarousel({
          items: 1,
          pager: true,
          nav: false,
          loop: true
        });
      }
      $('#carouselMobile').owlCarousel({
        items: 1,
        pager: true,
        nav: false,
        loop: true
      });
       
    }
    selectFaqMobile() { 
      $("#select-faq").on('change', function(e){
        e.preventDefault();
        var index = $(this).val();
        $('.listing-accordion > li').removeClass("active");
        $('.accordion').removeClass("active");
        $('.listing-accordion > li').eq(index).addClass("active");
        $('.accordion').eq(index).addClass("active");
      });
    }

  
}